import { API } from '../../http';

async function getAll({ page }) {
  return await API.get(`/cards?page=${page}`);
}
async function get(id) {
  return await API.get(`/card/${id}`);
}

async function search(searchValue) {
  return await API.get(`/cards/${searchValue}`);
}

async function createCard(card) {
  const { name_on_card, signature, picture, essences } = card;
  const formData = new FormData();

  formData.append('name_on_card', name_on_card);
  formData.append('signature', signature);
  formData.append('picture', picture);
  formData.append(
    'essences',
    JSON.stringify(
      essences.map((essence) => ({
        id: essence.essence_id,
        words: essence.words.map((word) => word.word),
      }))
    )
  );

  return await API.post('/cards', formData, {
    headers: { enctype: 'multipart/form-data' },
  });
}

async function updateCard(card) {
  const { id, name_on_card, signature, picture, essences } = card;
  const formData = new FormData();

  formData.append('name_on_card', name_on_card);
  formData.append('signature', signature);
  formData.append('picture', picture);
  formData.append(
    'essences',
    JSON.stringify(
      essences.map((essence) => ({
        id: essence.essence_id,
        words: essence.words.map((word) => word.word),
      }))
    )
  );

  return await API.put(`/card/${id}`, formData, {
    headers: { enctype: 'multipart/form-data' },
  });
}

async function deleteCard(id) {
  return await API.delete(`/card/${id}`);
}

async function addCardHieloco(card_id, hieloco_id) {
  return await API.post(`/card/${card_id}/hieloco`, { hieloco_id });
}

async function getCardHielocos(card_id) {
  return await API.get(`/card/${card_id}/hielocos`);
}

async function delelteCardHieloco(card_id, hieloco_id) {
  return await API.delete(`/card/${card_id}/hieloco/${hieloco_id}`);
}

const cardServices = {
  getAll,
  get,
  search,
  createCard,
  updateCard,
  deleteCard,
  addCardHieloco,
  getCardHielocos,
  delelteCardHieloco,
};

export default cardServices;
